import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { Form, Input, Button, Row, Col, TreeSelect, message, Table, Typography } from 'antd';
import { enquiryProducts, enquiryListSave } from '../api';
import './cartForm.less';

const layout = { labelCol: { span: 10, }, wrapperCol: { span: 14, }, };
const columns = [
  {
    title: '商品名称', key: 'sku_name', dataIndex: 'sku_name', align: 'center', render: (text, record) => {
      const { false_reason, add_cart } = record;
      return <><div>{text}</div><div><Typography.Link>{add_cart ? null : false_reason}</Typography.Link></div></>;
    }
  },
  { title: '商品分类', key: 'categorys', dataIndex: 'categorys', align: 'center', },
  { title: '商品规格', key: 'sale_norms', dataIndex: 'sale_norms', align: 'center', },
];
export const EnquiryCartProduct = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({ form }));
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [pageConfig, setPageConfig] = useState({ page: 1, page_size: 10 });
  const [selectItems, setSelectItems] = useState({ selectedRowKeys: [], selectedRows: [] });
  const [totalPage, setTotalPage] = useState(1);
  async function getEnquiryProducts() {
    const { often_id } = props;
    setSelectItems({ selectedRowKeys: [], selectedRows: [] });
    const formValues = form.getFieldsValue() || {};
    const { brand_id: brandId } = formValues;
    const brand_id = brandId ? [brandId] : brandId;
    const { data: { code, msg, data } } = await enquiryProducts({ ...formValues, brand_id, ...pageConfig, often_id });
    if (+code === 0) {
      const { list = [], total } = data;
      setDataSource(list.map((item,index)=>({...item,uniqueKey:`${item.sku_no}_${index}`})));
      setTotalPage(total);
    } else {
      message.error(msg);
    }
  }
  useEffect(() => {
    getEnquiryProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig]);
  const onFinish = () => {
    // getEnquiryProducts();
    setPageConfig({ ...pageConfig, page: 1 });
  };
  const onReset = () => {
    form.resetFields();
    setPageConfig({ ...pageConfig, page: 1 });
    // getEnquiryProducts();
  };

  const tablePageChange = (page, pageSize) => {
    setSelectItems({ selectedRowKeys: [], selectedRows: [] });
    setPageConfig({ ...pageConfig, page });
  };
  const rowSelection = {
    selectedRowKeys: selectItems.selectedRowKeys || [],
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectItems({ selectedRowKeys, selectedRows });
    },
    // getCheckboxProps: (record) => ({
    //   disabled: !record.add_cart,
    // }),
  };
  const addToCart = async () => {
    const { type } = props;
    const { selectedRows = [] } = selectItems;
    const result = {
      enquiryCart: async () => enquiryListSave({ data: selectedRows }),
      // often: async () => inventoryAddOftenList({ data: selectedRows, id: often_id }),
    };
    const { data: { code, msg } } = await result[type]() || {};
    if (+code === 0) {
      message.success(msg);
      props.refresh();
    } else {
      message.error(msg);
    }
  };
  return (
    <div className='cart-form'  style={{ minHeight: 500 }}>
      <Form className='cart-form-search' size='small' form={form} name="cartForm"  {...layout} onFinish={onFinish}>
        <Row>
          <Col span={8}><Form.Item name="sku_name" label='商品名称' className='cart-form-label'><Input placeholder="" /></Form.Item></Col>
          <Col span={8}>
            <Form.Item name="category_id" label='商品分类：' className='cart-form-label'>
              <TreeSelect
                treeData={(props?.categoryList || [])}
                maxTagCount={2}
                showSearch
                style={{ width: '100%', }}
                treeDataSimpleMode
                fieldNames={{ label: 'name', value: 'id', children: 'children' }}
                dropdownStyle={{ maxHeight: 200, overflow: 'auto', }}
                placeholder=""
                allowClear
                multiple
                filterTreeNode={(inputValue, treeNode) => treeNode.name.includes(inputValue)}
                treeDefaultExpandAll
              ></TreeSelect>
            </Form.Item>
          </Col>
          {/* <Col span={8}><Form.Item name="brand_id" label='品牌：' className='cart-form-label'><Select placeholder="">{(props?.brandList || []).map(item => <Option value={item.id} key={item.id}>{item.name}</Option>)}</Select></Form.Item></Col> */}
          <Col span={8}  style={{ textAlign: 'right' }}><Button type='primary' htmlType='submit'>搜索</Button><Button style={{ marginLeft: 8 }} onClick={onReset}>重置</Button><Button disabled={!selectItems.selectedRowKeys.length} style={{ marginLeft: 8 }} onClick={addToCart} type='primary'>添加商品</Button></Col>
        </Row>
      </Form>
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey='uniqueKey'
        locale={{ emptyText: '未搜索到商品' }}
        rowSelection={rowSelection}
        scroll={{ y: 390, }}
        pagination={{
          pageSize: pageConfig.page_size,
          total: totalPage,
          current: pageConfig.page,
          onChange: tablePageChange
        }} />
      {/* {dataSource?.length ? null : <Empty image={false} description='未搜索到商品' />} */}
    </div>
  );
});